<template>
    <div class="widget-container">
        <QuillEditor
            v-model:content="model"
            content-type="html"
            theme="snow"
            toolbar="full"
            :style="{ height: 'calc(100vh - 140px)' }"
        />
    </div>
</template>
<script setup lang="ts">
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

const model = defineModel<string>();
</script>
<style scoped>
.widget-container {
    height: calc(100vh - 140px);
}

:deep(.ql-toolbar) {
    background-color: #f5f5f5;
    border: 1px solid #dbdbdb;
}

:deep(.ql-container) {
    background-color: #ffffff;
    border: 1px solid #dbdbdb;
    color: #1f1f1f;
    font-size: 14px;
}

:deep(.ql-editor) {
    min-height: 200px;
    font-size: 14px;
}

:deep(.ql-editor img) {
    vertical-align: middle;
    padding-right: 10px;
    max-width: 100%;
}

:deep(.ql-editor blockquote) {
    border-left: 4px solid var(--color-border);
    margin: 0.5rem 0;
    padding-left: 1rem;
    font-style: italic;
    color: var(--color-text-muted);
}

:deep(.ql-editor pre.ql-syntax) {
    background: var(--color-bg-code);
    border: 1px solid var(--color-border);
    border-radius: 0.5rem;
    padding: 1rem;
    overflow-x: auto;
    margin: 0.5rem 0;
    font-family: "Courier New", Courier, monospace;
    font-size: 0.875rem;
}
</style>
